export const UNASSIGN_USER_OPTION = {
  id: 'none',
  name: 'None',
};
